import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';




import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';


import {CalendarDepartFileService} from '../../../service/calendar/service-calendardepartfile';
import {CalendarDepartFile} from '../../../models/calendar/calendardepartfile';
import {CommandUtil} from '../../../global/commandutil';
import {language} from '../../../language/vn';
import {CalendarDepart} from '../../../models/calendar/calendardepart';
import {CalendarDepartService} from '../../../service/calendar/service-calendardepart';

@Component({
  templateUrl: './file.component.html'

})
export class FileLichDonViComponent implements OnInit, AfterViewInit {



  public language = language;
  public  onClose: Subject<boolean>;
  public dataFiles: CalendarDepartFile[]=[];
  public calendarItem: CalendarDepart= new CalendarDepart();
  constructor(  public bsModalService: BsModalService,
                public _bsModalRef: BsModalRef,
                public commandUtils: CommandUtil,
                public calendarDepartService: CalendarDepartService,
                public calendarDepartFileService: CalendarDepartFileService
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  public edit(id: number) {

    this.calendarDepartFileService.findAllByCalendarId(id).subscribe(data=> this.dataFiles= data);
    this.calendarDepartService.getById(id).subscribe( data=> this.calendarItem = data);

  }

  ngOnInit(): void {
    this.onClose = new Subject();


  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

